import React from 'react';
import { gql } from '@urql/core';
import { Espin_Message_Type_Enum, MessageContainerFragment } from '../../../generated/spin-graphql';
import { CollegeSendsMessage } from './colleges/CollegeSendsMessage';
import { PlayerSendsMessage } from './players/PlayerSendsMessage';
import { HighSchoolSendsMessage } from './high-school/HighSchoolSendsMessage';

type Props = {
    message: MessageContainerFragment;
};

gql`
    fragment MessageContainer on espin_message {
        message_type
        ...PlayerSendsMessage
        ...CollegeSendsMessage
        ...HighSchoolSendsMessage
    }
`;

export const MessageContainer: React.FC<Props> = ({ message }) => {
    return (
        <>
            {(message.message_type === Espin_Message_Type_Enum.CollegeMessagesPlayer ||
                message.message_type === Espin_Message_Type_Enum.CollegeMessagesHighSchool) && (
                <CollegeSendsMessage message={message} />
            )}
            {message.message_type === Espin_Message_Type_Enum.PlayerMessagesCollege && (
                <PlayerSendsMessage message={message} />
            )}
            {message.message_type === Espin_Message_Type_Enum.HighSchoolMessagesCollege && (
                <HighSchoolSendsMessage message={message} />
            )}
        </>
    );
};
